export default ['osc-product-feed']
